import { setConfiguration } from '@configuratorware/configurator-frontendgui/App/configuration';
import Api from '@configuratorware/configurator-frontendgui/Framework/Api';
import AppReducer from '../Reducers/App/Reducer';
import ConfiguratorReducer from '../Reducers/Configurator/Reducer';
import MachineInstanceReducer from '../Reducers/MachineInstance/Reducer';
import ConfiguratorScreen from '../Screens/ConfiguratorScreen';
import ConfiguratorService from '../Services/ConfiguratorService';
import VisualizationService from '../Services/VisualizationService';
import InteractionService from '../Services/InteractionService';

const prod = process.env.NODE_ENV === 'production';

const envDomains = {
  test: '',
  int: '',
  local: 'http://localhost:10790',
  //local: 'https://int.ipco.local',
  prod: '',
};

const domain = envDomains[prod ? 'prod' : 'local'];

const query = new URLSearchParams(location.search);

const adminMode = query.get('_adminmode');

const customApplicationConfiguration = {
  network: {
    // timeout: 40000,
    host: domain,
    baseURL: `${domain}/frontendapi/`,
    adminBaseURL: `${domain}/api/`,
    imageURL: `${domain}`,
    resourcesURL: `${domain}`,
  },
  screens: {
    Configurator: ConfiguratorScreen,
    ItemOverview: ConfiguratorScreen,
  },
  services: {
    ConfiguratorService,
    VisualizationService,
    InteractionService,
  },
  locales: [{ code: 'de_DE', preferred: true }, { code: 'en_GB' }],
  reducers: {
    ipco: AppReducer,
    configurator: ConfiguratorReducer,
    machineInstance: MachineInstanceReducer,
  },
};

setConfiguration(customApplicationConfiguration);

if (adminMode) {
  // in admin mode all requests should contain the no-cache header to get the most fresh content
  Api.setCacheControlHeader('no-cache');
}

export default customApplicationConfiguration;
